import { useContext } from 'react';
import { Col, Row } from 'reactstrap';
import logo from '../../../../../images/user.png';
import { PartnerContextDetails } from '../../partnerDetailsContext';
import PageLoader from 'common/PageLoader';
import Header from 'components/Header';
import PageContainer from 'common/PageContainer';
import StatusComponent from 'pages/Customers/components/CustomerDetail/components/CustomerStatus';

const Index = () => {
  const context = useContext(PartnerContextDetails);

  if (!context) return <p>Partner context not available</p>;

  const { isLoading, error, data, status } = context.partnerDetails;

  const chef = data?.chef;

  if (isLoading) return <PageLoader />;
  if (error || !chef) {return <p>'Something went wrong!'</p>;}
  if (status === 200) {
    return (
      <PageContainer>
        <Header totalCount={null} heading={'Partners'} />
        <Row>
          <Col xs="10" md="2">
            <img
              src={logo}
              alt="User"
              className="mt-3 ms-4 img-fluid rounded-circle"
              style={{ height: '150px', width: '150px', objectFit: 'cover' }}
            />
          </Col>
          <Col xs="12" md="10">
            <Row>
              <Col md="2" className="pt-3">
                <h6 className="mb-0 adminLabel">Name</h6>
                <p className="mb-2 adminDetail">
                  {`${chef.firstName || ''} ${chef.lastName || ''}`.trim() ||
                    'N/A'}
                </p>
              </Col>
              <Col md="2" className="pt-3">
                <h6 className="mb-0 adminLabel">Date of Birth</h6>
                <p className="mb-2 adminDetail">{chef.dateOfBirth || 'N/A'}</p>
              </Col>
              <Col md="2" className="pt-3">
                <h6 className="mb-0 adminLabel">Gender</h6>
                <p className="mb-2 adminDetail">{chef.gender || 'N/A'}</p>
              </Col>
            </Row>
            <Row>
              <Col md="2" className="pt-3">
                <h6 className="mb-0 adminLabel">Email</h6>
                <p className="mb-2 adminDetail">{chef.email || 'N/A'}</p>
              </Col>
              <Col md="2" className="pt-3">
                <h6 className="mb-0 adminLabel">Phone</h6>
                <p className="mb-2 adminDetail">{chef.phone || 'N/A'}</p>
              </Col>
              <Col md="2" className="pt-3" >
              <StatusComponent
                customerId={chef.id}
                initialStatus={
                  chef?.status === 1
                    ? 'Pending'
                    : chef?.status === 2
                    ? 'Approved'
                    : chef?.status === 3
                    ? 'Rejected'
                    : 'N/A'
                }
                onUpdate={(newStatus: any) => {
                  console.log('Updated status.......:', newStatus);
                }}
                role={chef.role}
              />
              </Col>
            </Row>

            <Col xs="4">
              <h6 className="mb-0 adminLabel mt-2">Address</h6>
              <p className="mb-2 adminDetail">{chef.address || 'N/A'}</p>
            </Col>
          </Col>
        </Row>

        <Row className="mt-4 ms-4">
          <Col md="4">
            <h5 className='adminSubheading' >Document</h5>
            <Row>
              <Col md="4">
                <h6 className="mb-0 adminLabel">PAN Number</h6>
                <p className="mb-2 adminDetail">{chef.idProofType || 'N/A'}</p>
              </Col>
              <Col md="4">
                <h6 className="mb-0 adminLabel">Adhara Card</h6>
                <p className="mb-2 adminDetail">{chef.idProofNumber || 'N/A'}</p>
              </Col>
            </Row>
          </Col>

          <Col md="6" >
            <h5 className='adminSubheading' >Other Info</h5>
            <Row>
              <Col>
                <h6 className="mb-0 adminLabel ">Designation</h6>
                <p className="mb-2 adminDetail ">{chef.designation || 'N/A'}</p>
              </Col>
              <Col>
                <h6 className="mb-0 adminLabel">Experience</h6>
                <p className="mb-2 adminDetail">{chef.totalExperience || 'N/A'}</p>
              </Col>
              <Col>
                <h6 className="mb-0 adminLabel">Current Work Location</h6>
                <p className="mb-2 adminDetail">{chef.currentWorkLocation || 'N/A'}</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </PageContainer>
    );
  }
  return null;
};

export default Index;
